import React from 'react';
import Select from 'react-select';
import { selectStyles, selectTheme } from './SelectStyles';
import './select-portal-styles.css';

export interface SelectOption {
  value: string;
  label: string;
}

interface SingleSelectProps {
  name: string;
  options: SelectOption[];
  placeholder: string;
  onChange: (selectedOption: any) => void;
  defaultValue?: SelectOption;
  className?: string;
  width?: string;
}

const SingleSelect: React.FC<SingleSelectProps> = ({
  name,
  options,
  placeholder,
  onChange,
  defaultValue,
  className = "text-sm",
  width = "w-48"
}) => {
  return (
    <div className={`relative ${width} select-container 
      [--select-bg:white] 
      dark:[--select-bg:rgb(31,41,55)] 
      [--select-text:rgb(17,24,39)] 
      dark:[--select-text:rgb(243,244,246)] 
      [--select-border:rgb(156,163,175)] 
      dark:[--select-border:rgb(75,85,99)] 
      [--select-hover:rgb(243,244,246)] 
      dark:[--select-hover:rgb(55,65,81)] 
      [--select-active:rgb(219,234,254)] 
      dark:[--select-active:rgb(55,65,81)] 
      [--select-multi-bg:rgb(219,234,254)] 
      dark:[--select-multi-bg:rgb(55,65,81)] 
      [--select-multi-text:rgb(30,58,138)] 
      dark:[--select-multi-text:rgb(243,244,246)] 
      [--select-placeholder:rgb(107,114,128)] 
      dark:[--select-placeholder:rgb(156,163,175)]`}>
      <Select
        name={name}
        options={options}
        className={`${className} select-component`}
        classNamePrefix="select"
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        styles={{
          ...selectStyles,
          container: (base) => ({
            ...base,
            width: '100%',
          }),
          control: (base, state) => ({
            ...selectStyles.control(base, state),
            minWidth: 'min-content',
          })
        }}
        theme={selectTheme}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default SingleSelect; 